import { DocumentHistory } from "./document-history";
import { RequestWorkflow } from "./request-workflow";
import { Milestones } from "./state";
import { AppEnviroment } from './app-enviroment';

export class RequestBase {
  Id: number | string = 0;
  CreationDate: Date;
  CreationUser: number;
  Description: string;
  Edition: string;
  RequestType: RequestTypes;
  Active = true;
  Observation: string;
  DocumentStateId: Milestones = Milestones.Pending;
  StateHistory: DocumentHistory[];
  Workflows: RequestWorkflow[] = [];

  get StateName(): string {
    return AppEnviroment.Translate.instant("millestones." + Milestones[this.DocumentStateId]);
  }

  get RequestTypeName(): string {
    return AppEnviroment.Translate.instant("requestTypes." + RequestTypes[this.RequestType]);
  }

}


export enum RequestTypes {
  Supply,
  Delegate,
  Group,
  CreateUserAccount,
  EditUserAccount,
  UserActivation,
  UserInactivation,
  PAM,
  EndUser,
  ResetUserCredentials,
  AssignLicenses
}


